import Select from './Select';

import Input from './Input';
import InputTextarea from './InputTextarea';
import InputCheckbox from './InputCheckbox';
import InputButton from './InputButton';
import InputNumber from './InputNumber';

export default { Select, Input, InputTextarea, InputCheckbox, InputButton, InputNumber };
